const id_master_process = {
    "": "proses",
    add: "tambah proses",
    can_change: "dapat diubah",
    edit: "ubah proses",
    name: "nama proses",

    form: {
        can_change_title: "ubah di transaksi *",
        can_change_label: "aktifkan untuk mengubah saat transaksi",
        btn_add_detail1: "tambah bahan baku",
        btn_add_detail2: "tambah hasil proses",
    },

    error: {
        name: "Nama proses tidak boleh kosong.",
        create: "Gagal membuat proses.",
        delete: "Gagal menghapus proses.",
        edit: "Gagal mengubah proses.",
    },

    success: {
        create: "Berhasil membuat proses.",
        delete: "Berhasil menghapus proses.",
        edit: "Berhasil mengubah proses.",
    }
}

export default id_master_process;